<template>
  <div>
    <h3 class="mb-5">Product Gallery</h3>
    <div class="h4 mb-5">
      顯示於產品頁Information區塊，前端可切換顯示不同視角產品圖，請至少上傳6張
    </div>

    <label class="form-item d-flex py-3">
      <div class="w-200px">
        <h4>Product Color</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2">
        <v-combobox
          v-model="color"
          :items="product.colors"
          item-text="name"
          outlined
          dense
        >
        </v-combobox>
      </div>
    </label>
    <div v-if="color != null">
      <!-- items -->
      <PageCollapse v-for="(item, i) in color.images" :key="i">
        <template v-slot:head>
          <h3 class="mr-auto">{{ i + 1 }}</h3>
        </template>
        <template v-slot:actions>
          <div class="ml-auto">
            <button class="btn square mr-10px" @click="deleteItem(i)">
              <v-icon class="ink-02-medium--text">delete</v-icon>
            </button>
            <button class="btn square mr-10px" @click="downItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_downward</v-icon>
            </button>
            <button class="btn square" @click="upItem(item, i)">
              <v-icon class="ink-02-medium--text">arrow_upward</v-icon>
            </button>
          </div>
        </template>
        <template v-slot:body>
          <!-- img uploader -->
          <div class="d-flex px-5 pt-5 mb-8">
            <div class="w-180px">
              <h4 class="mb-10px">圖片</h4>
              <div class="h5 ink-02-medium--text">
                ADATA 與 XPG: 2000 px X 2000 px<br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                :dir="dir"></ImgUploader>
            </div>
          </div>
        </template>
      </PageCollapse>

      <!-- 添加 item -->
      <div class="mt-5">
        <button class="btn btn-outlined w-100 justify-start" @click="addItem">
          <v-icon class="primary--text mr-2">add_circle</v-icon>
          <span>添加圖片</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUploader from '@/components/ImgUploader.vue';
import PageCollapse from '@/components/PageCollapse.vue';

export default {
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ImgUploader,
    PageCollapse,
  },
  data: () => ({
    dir: 'product',
    color: null,
  }),
  methods: {
    addItem() {
      const template = {
        id: null,
        visual: '',
      };
      this.color.images.push(template);
    },
    deleteItem(index) {
      this.color.images.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.color.images.length - 1) {
        this.color.images.splice(i, 1);
        this.color.images.unshift(item);
        return;
      }
      // item become next index
      this.color.images.splice(i, 1);
      this.color.images.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.color.images.splice(i, 1);
        this.color.images.push(item);
        return;
      }
      // item become previous index
      this.color.images.splice(i, 1);
      this.color.images.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
